import { RawOrganisationData, SoftwareVersion } from './types'
import { managementApi } from '@frontend/core'

const tagType = 'adminOrganisations' as const

export const adminApi = managementApi.injectEndpoints({
  endpoints: (builder) => ({
    //Returns ALL organisations regardless of the user's permissions - can only be requested
    //by a SportableSuperAdmin
    getAllAdminOrganisations: builder.query<RawOrganisationData[], void>({
      query: () => 'admin/organisations',
      providesTags: [{ type: tagType, id: 'LIST' }]
    }),

    getSoftwareForOrganisation: builder.query<SoftwareVersion[], string>({
      query: (org) => `organisations/${org}/software`
    })
  })
})

export const {
  useGetAllAdminOrganisationsQuery,
  useGetSoftwareForOrganisationQuery
} = adminApi
